import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '@services/http-service';
import { ConfigService } from '@services/webFeeder/config.service';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { Observable, Subscription , of } from 'rxjs';
import { SocketService } from '@services/webFeeder/socket.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {

  public showNavBarEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  private authenticated = false;
  private userLogged: string;
  private userLoginObserver: Subscription;

  constructor(
    private router: Router,
    private svcHttp: HttpService,
    private configService: ConfigService,
    private autoLogoutService: AutoLogoutService,
    private socketService: SocketService
  ) {
    this.userLoginObserver = this.socketService.statusWFLogin$.subscribe(isLoged => {
      if (!isLoged) {
        this.logoutWithoutRouter();
      }
    });
  }
  ngOnDestroy(): void {
    if (this.userLoginObserver) {
      this.userLoginObserver.unsubscribe();
    }
  }

  private clearSession() {
    this.authenticated = false;
    this.showNavBar(false);
    this.configService.deleteHbCurrentUser();
    this.autoLogoutService.logout();
    this.configService.deleteCookie();
  }

  public logoutSession(): boolean {
    if (this.authenticated) {
      this.configService.REDIRECT_LOGOUT();
      this.clearSession();
      return true;
    }
    return false;
  }

  public logout() {
    this.clearSession();
    this.socketService.logout();
    if (!this.configService.isLoginTypeAdapter()) {
      this.router.navigate(['/logout']);
    }
  }

  public logoutWithoutRouter() {
    this.clearSession();
    this.socketService.logout();
  }

  public sessionExpired() {
    this.clearSession();
    this.configService.redirectExpireSession();
  }
  public isAuthenticated(viaLogin: boolean) {
    return this.authenticated;
  }

  valideToken(account: string, tokenApi: string, tokenWF: string): Observable<any> {
    return this.svcHttp
      .doPost(this.configService.getUrlApiFacade(true), 'services/Authenticate/ValideToken',
        "{'account':'" + account + "', 'tokenA':'" + tokenApi + "', 'tokenW':'" + tokenWF + "'}"
      ).pipe(
        map(async response => {
          if (response) {
            const json = await response;
            if (json['accountNumber'] && json['accountNumber'] !== null && json['accountNumber'] !== '') {
              this.authenticated = true;
              this.userLogged = json['accountNumber'];
              this.autoLogoutService.login();
              return {
                success: true,
                token: json['token'],
                guidUser: json['guidUser'],
                tokenWS: json['tokenWS'],
                account: json['accountNumber']
              };
            } else {
              this.authenticated = false;
            }
            if (!json['message'] && !json['codeMessage']) {
              throw new Error('noNetworkError');
            }
            return [];
          }
        }
        )
      );
  }

  public loginViaToken(tokenAuth: string): Observable<any> {
    return this.svcHttp
      .doPost(this.configService.getApiWebFeederRest(), 'services/Authenticate/PostLogin', "{'token':'" + tokenAuth + "'}")
      .pipe(map(response => {
        if (response) {
          const json = response;
          if (json.code) {
            this.authenticated = false;
            this.configService.writeLog('Auth > RESPONSE_LOG');
          } else if (json.accountNumber) {
            this.authenticated = true;
            this.userLogged = json.accountNumber;
            if (tokenAuth.length <= 5) {
              this.userLogged = tokenAuth;
            }
            this.autoLogoutService.login();
            return {
              success: true,
              token: json.token,
              tokenWS: json.tokenWS,
              guidUser: json.guidUser,
              account: json.accountNumber
            };

          } else {
            this.authenticated = false;
          }
          return [];
        }
        return [];
      }));
  }

  public getUserLogged() {
    if (!this.userLogged) {
      const userLogged: any = this.configService.getHbCurrentUser();
      if (userLogged && userLogged.username) {
        this.userLogged = userLogged.username;
      } else if (userLogged && userLogged.name) {
        this.userLogged = userLogged.name.split(' ')[0];
      } else {
        this.configService.writeLog('AUTH > GETUSERLOGGED: usuario não encontrado.');
        this.configService.redirectExpireSession();
        return false;
      }
    }
    return this.userLogged;
  }

  public setUserLogged(userlogged: string) {
    this.authenticated = true;
    this.userLogged = userlogged;
    this.autoLogoutService.login();
  }

  private showNavBar(ifShow: boolean) {
    this.showNavBarEmitter.emit(ifShow);
  }

}
